module.exports = __webpack_public_path__ + "img/i_speech.23cd128b.svg";